import StyledContainer from '@design-system/styled/Container';
import styled from 'styled-components';

export const Container = styled(StyledContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  padding-bottom: 35px;
  background-color: #ffffff;
  width: 100%;
`;

export const Title = styled.h2`
  ${(props) => props.theme.typo.familyGoogle.medium};
  font-size: 22px;
  line-height: 130%;
  text-align: center;
  color: #ff5722;
  margin-bottom: 25px;

  @media (min-width: 768px) {
    font-size: 33px;
    line-height: 40px;
  }
`;

export const CardGrid = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 25px;

  @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 51px;
    padding: 32px 0px 43px;
    max-width: 768px;
  }

  @media (min-width: 1024px) {
    gap: 42px;
    padding: 60px 15px;
    max-width: 876px;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;

  @media (min-width: 768px) {
    width: 307px;
  }

  @media (min-width: 1024px) {
    width: 375px;
  }
`;

export const IconContainer = styled.div`
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  @media (min-width: 768px) {
    width: 69px;
    height: 69px;
  }

  img {
    width: 100%;
    height: 100%;
  }
`;

export const CardTitle = styled.h3`
  ${(props) => props.theme.typo.familyGoogle.bold};
  font-size: 16px;
  line-height: 23px;

  text-align: center;
  color: #ff5722;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

export const CardDescription = styled.p`
  ${(props) => props.theme.typo.familyGoogle.medium};
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #363636;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const Divider = styled.div`
  width: 152px;
  height: 1px;
  background-color: #ff5722;
  margin: 0 auto;

  @media (min-width: 768px) {
    display: none;
  }
`;
